module.exports = __webpack_public_path__ + "static/media/defaultEDULogo.ce95c947.webp";